/* global http preloader scrollToElement */

const filterTrials = {
	el: {
		body: document.body,
		container: document.querySelector('.js-filter-trials'),
		grid: document.querySelector('.filter__grid'),
		searchForm: document.querySelector('.js-form-trials'),
		searchInput: document.querySelector('.hero-search__input'),
		checkboxes: document.querySelectorAll('.js-filter-checkbox'),
		checkboxesStatus: document.querySelectorAll('.js-filter-checkbox-status'),
		checkboxesGender: document.querySelectorAll('.js-filter-checkbox-gender'),
		checkboxesType: document.querySelectorAll('.js-filter-checkbox-type'),
		checkboxesPhase: document.querySelectorAll('.js-filter-checkbox-phase'),
		checkboxesAge: document.querySelectorAll('.js-filter-checkbox-age'),
		checkboxesCondition: document.querySelectorAll('.js-filter-checkbox-condition'),
		totalResultsText: document.querySelector('.js-total-results'),
		firstIndexText: document.querySelector('.js-first-index'),
		lastIndexText: document.querySelector('.js-last-index'),
		paginationContainer: document.querySelector('.js-filter-pagination'),
		searchPressed: false
	},

	vars: {
		currentPage: 1
	},

	fxGetCheckedValues(elements) {
		return [...elements].filter(checkbox => checkbox.checked).map(checked => checked.value)
	},

	fxRenderItems(element, page) {
		const container = this.el.container,
			input = this.el.searchInput,
			currentPage = page ? Number(page) : this.vars.currentPage

		const formData = {
			pageId: Number(container.dataset.id),
			currentPage: currentPage,
			age: this.fxGetCheckedValues(this.el.checkboxesAge),
			gender: this.fxGetCheckedValues(this.el.checkboxesGender),
			status: this.fxGetCheckedValues(this.el.checkboxesStatus),
			phase: this.fxGetCheckedValues(this.el.checkboxesPhase),
			type: this.fxGetCheckedValues(this.el.checkboxesType),
			condition: this.fxGetCheckedValues(this.el.checkboxesCondition),
			term: input.value,
			language: this.el.body.dataset.language
		}

		const callback = (response, data) => {
			preloader.fxPreloaderRemove(container)

			const success = () => {
				const items = data.items,
					grid = this.el.grid,
					pagination = this.el.paginationContainer,
					totalResults = this.el.totalResultsText,
					firstIndex = this.el.firstIndexText,
					lastIndex = this.el.lastIndexText

				grid.innerHTML = ''
				for (const item of items) {

					let status = ''

					for (const subitem of item.status) {
						status += `<div class='filter__status filter__status--${subitem.state}'>${subitem.type}</div>`
					}

					grid.innerHTML +=
						`
							<a class='filter__card' href='${item.url}'>
								<div class='filter__card-row'>${status}</div>
								<div class='filter__card-row'>
									<h3 class='filter__card-heading epsilon'>${item.title}</h3>
								</div>
								<div class='filter__card-row'>
									<div class='filter__card-column'>
										<div class='filter__card-text'>${grid.dataset.copySex}</div>
										<div class='filter__card-text filter__card-text--regular omega'>${item.sex}</div>
									</div>
									<div class='filter__card-column'>
										<div class='filter__card-text'>${grid.dataset.copyAge}</div>
										<div class='filter__card-text filter__card-text--regular omega'>${item.age}</div>
									</div>
									<div class='filter__card-column'>
										<div class='filter__card-text'>${grid.dataset.copyLocation}</div>
										<div class='filter__card-text filter__card-text--regular omega'>${item.location}</div>
									</div>
								</div>
								<div class='filter__card-row'>
									<div class='filter__card-link'>
										<span class='link'>${grid.dataset.copyInfo}</span>
										<svg class='filter__card-arrow' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'>
											<path d='M5 12h14m-7-7l7 7-7 7'></path>
										</svg>
									</div>
								</div>
							</a>
						`
				}
				const itemsPerPage = 10
				totalResults.textContent = data.totalRecords
				firstIndex.textContent = items.length ? currentPage * itemsPerPage - (itemsPerPage - 1) : 0
				lastIndex.textContent =  items.length === itemsPerPage ? currentPage * itemsPerPage : (currentPage - 1) * itemsPerPage + items.length

				pagination.innerHTML = ''

				for (let i = 0; i < data.pages.length; i++) {
					const active = !element && i === 0 || element && Number(element.textContent) === i + 1 ? 'active' : ''
					pagination.innerHTML += `<button class='filter__pagination-page js-pagination-item js-scrollto ${active}' data-scroll='grid' type='button'>${data.pages[i]}</button>`
				}

				for (const page of document.querySelectorAll('.js-pagination-item')) {
					page.addEventListener('click', e => {
						const target = e.currentTarget
						if (!isNaN(target.textContent)) {
							this.fxRenderItems(target, Number(target.textContent))
							scrollToElement.fxScrollTo(e)
						}
					})
				}

				//Scroll to results on search submit
				if (this.el.searchPressed === false) return
				container.scrollIntoView({ behavior: 'smooth' })
			}

			//TODO error 500
			const error = () => {}

			switch (response.status) {
				case 200:
					success()
					break
				case 500:
					error()
					break
			}
		}
		preloader.fxPreloaderAdd(container)
		http.fxPost(container.dataset.endpoint, formData, callback)
	},

	fxToggleCheckboxes(checkbox) {
		if (checkbox.value === 'all') {
			[...this.el.checkboxes].filter(checkbox => checkbox.checked).map(checkbox => checkbox.checked = false)
			this.el.checkboxes[0].checked = true
		}
		else
			this.el.checkboxes[0].checked = false
	},

	events() {
		for (const checkbox of this.el.checkboxes)
			checkbox.addEventListener('change', () => {
				this.fxToggleCheckboxes(checkbox)
				this.fxRenderItems()
			})

		this.el.searchForm.addEventListener('submit', e => {
			e.preventDefault()
			this.el.searchPressed = true
			this.fxRenderItems()
		})
	},

	init() {
		if (this.el.container) {
			const interventionalCheckbox = this.el.container.querySelector('.js-filter-checkbox[value="Interventional"]')
			this.events()

			if (this.el.searchPressed === false && interventionalCheckbox) {
				for (const checkbox of this.el.checkboxes) {
					if(checkbox.value === 'Interventional') {
						checkbox.checked = true

						if (!interventionalCheckbox.closest('.filter__field').hasAttribute('open')) interventionalCheckbox.closest('.filter__field').setAttribute('open', null)
					} else {
						checkbox.checked = false
					}
				}
			}

			this.fxRenderItems()
		}
	}
}

filterTrials.init()
